import { marked } from "marked";
import TurndownService from "turndown";

marked.setOptions({
  gfm: true,
  breaks: false,
  mangle: false,
  headerIds: false
});

const turndown = new TurndownService({
  headingStyle: "atx",
  bulletListMarker: "-",
  codeBlockStyle: "fenced",
  emDelimiter: "*",
  strongDelimiter: "**"
});

/** Markdown → HTML для TipTap setContent. */
export function markdownToHtml(markdown) {
  const src = String(markdown ?? "").trim();
  if (!src) return "<p></p>";
  return marked.parse(src);
}

/** HTML редактора → Markdown для сохранения. */
export function htmlToMarkdown(html) {
  if (!html) return "";
  return turndown.turndown(html).trim();
}
